const ACTIONS = {
    CHANGED_SELECTED_DATES: 'DATE_PICKER/CHANGED',
    SUBMIT_SELECTED_DATES: 'DATE_PICKER/SUBMIT',
    DISABLED_DAY_CLICK_ATTEMPT: 'DATE_PICKER/DISABLED_DAY_CLICK_ATTEMPT',
    DATE_INPUT_FOCUS: 'DATE_PICKER/DATE_INPUT_FOCUS',
    UPDATE_DATE_PICKER_STATE: 'DATE_PICKER/UPDATE_DATE_PICKER_STATE'
};

const ACTION_CREATORS = {
    changedSelectedDates(fieldsChanged) {
        return {
            type: ACTIONS.CHANGED_SELECTED_DATES,
            payload: {fieldsChanged}
        };
    },
    submitSelectedDates() {
        return {
            type: ACTIONS.SUBMIT_SELECTED_DATES,
            payload: {}
        };
    },
    disabledDayClickAttempt(date) {
        return {
            type: ACTIONS.DISABLED_DAY_CLICK_ATTEMPT,
            payload: {date}
        };
    },
    dateInputFocus(isCheckout) {
        return {
            type: ACTIONS.DATE_INPUT_FOCUS,
            payload: {selectingCheckout: isCheckout}
        };
    },
    updateDatePickerState(datePickerStates = {
        datePickerPrevState: 'CLOSED',
        datePickerState: 'CLOSED'
    }) {
        return {
            type: ACTIONS.UPDATE_DATE_PICKER_STATE,
            payload: {
                datePickerPrevState: datePickerStates.datePickerPrevState,
                datePickerState: datePickerStates.datePickerState
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
